/**
 * Dictation (#541) — the Main Chat microphone transcribes speech straight INTO
 * the message box instead of queueing a voice note.
 *
 * `appendDictation(existing, text)` is the one rule for where a transcription
 * lands: AFTER whatever the user already typed or edited, never over it, joined
 * by exactly one space. Pure, so the composer and the off-screen draft path
 * (user switched conversation while the clip was transcribing) can never
 * disagree.
 *
 *   appendDictation('', 'hello')          → 'hello'
 *   appendDictation('Note:', 'buy milk')  → 'Note: buy milk'
 *   appendDictation('Note: ', 'buy milk') → 'Note: buy milk'   (no double space)
 *   appendDictation('line\n', 'next')     → 'line\nnext'       (a newline is a separator)
 *   appendDictation('Note:', '')          → 'Note:'            (empty STT inserts nothing)
 */
export function appendDictation(existing, text) {
    const base = typeof existing === 'string' ? existing : '';
    const addition = typeof text === 'string' ? text.trim() : '';
    if (!addition) return base;
    if (!base) return addition;
    if (/\s$/.test(base)) {
        // Collapse trailing spaces/tabs to a single space, but keep a deliberate
        // line break the user typed (Shift+Enter) as the separator.
        if (/\n[ \t]*$/.test(base)) return base.replace(/[ \t]+$/, '') + addition;
        return base.replace(/[ \t]+$/, ' ') + addition;
    }
    return `${base} ${addition}`;
}
